import { useCallback, useState } from "react";

import { useNavigate } from "react-router-dom";

import { RouteConstants } from "constant";
import { AgentService } from "services";
import { AppUtils } from "utils";

const { ROUTE_LOGIN } = RouteConstants;

const useStartBreak = () => {
  const navigate = useNavigate();
  const [startingBreak, setStartingBreak] = useState(false);

  const startBreak = useCallback(async () => {
    try {
      setStartingBreak(true);
      await AgentService.agentBreakStart();
      AppUtils.logout();
      navigate(ROUTE_LOGIN);
    } finally {
      setStartingBreak(false);
    }
  }, [navigate]);

  return { startBreak, startingBreak };
};

export default useStartBreak;
